import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Menu from '../pages/Menu';

const MenuWrapper: React.FC = () => {
  const { vendorId } = useParams<{ vendorId: string }>();
  const navigate = useNavigate();
  
  // IMPORTANT: Handle navigation when vendorId is missing
  useEffect(() => {
    // If we're trying to view /menu/:vendorId but vendorId param is missing,
    // redirect to /qr to avoid broken page state
    if (!vendorId) {
      console.log('MenuWrapper: No vendorId param present, redirecting to QR page');
      navigate('/qr', { replace: true });
      return;
    }
    
    if (process.env.NODE_ENV === 'development') {
      console.log('MenuWrapper: Rendering menu for vendorId:', vendorId);
    }
  }, [vendorId, navigate]);

  // Don't force remount - let Menu component handle vendor changes
  return <Menu />;
};

export default MenuWrapper;
